{
	"aiStyleDeleted": "AI Style Deleted",
	"aiStyleDeletedDescription": "The AI Style in this project was deleted. How would you like to continue?",
	"aiStyleUpdated": "AI Style Updated",
	"aiStyleUpdatedDescription": "The AI Style in this project was updated. How would you like to continue?",
	"cancelOpeningTitle": "Cancel Opening Project",
	"cancelOpeningMessage": "Are you sure you want to cancel? This will return to the homepage. You can re-open and set up this project anytime",
	"closeProject": "Close Project",
	"failedToUpdate": "Failed to update AI Style. Please try again.",
	"keepEditsOption": "Keep the edits in this project as-is (this will create a new AI Style)",
	"reprocessOption": "Re-process this project with the updated AI Style",
	"selectNewOption": "Select a new AI Style",
	"updatedSuccessfully": "AI Style updated successfully.",
	"updating": "Updating AI Style..."
}
